module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6e3vq"))).then(() => parcelRequire('4cCDm'));